// extracted by mini-css-extract-plugin
module.exports = {"tilt":"style_tilt__1Bq5i"};